module.exports = __webpack_public_path__ + "static/media/chrome.c365dfbe.svg";